'use client'

import classnames from 'classnames'
import styles from './JoinWaitlist.module.scss'
import Link from '@/components/Button/Button'
import useI18n from '@/hooks/use-i18n'
import { useMemo } from 'react'

interface JoinWaitlistProps {
  className?: string
  waitlistTime: string
  primary?: boolean
  secondary?: boolean
  onClick?: () => void
  businessId?: string
  waitlistStatus?: string
  closedReason?: string | null
}

const JoinWaitlist = ({
  className,
  waitlistTime,
  primary = false,
  secondary,
  onClick,
  businessId,
  waitlistStatus,
  closedReason,
}: JoinWaitlistProps) => {
  const { i18n } = useI18n()

  const isClosed = !waitlistStatus || (waitlistStatus === 'CLOSED' && closedReason !== 'no_current_wait')

  const buttonLabel = useMemo(() => {
    if (waitlistStatus === 'LOADING') {
      return i18n('joinWaitlistLoading')
    }


    if (isClosed) {
      return i18n('joinWaitlistClosed')
    }

    const waitTimeNumber = Number(waitlistTime)
    const hasWaitTime = waitlistTime && waitTimeNumber !== 0

    return hasWaitTime
      ? `${waitlistTime} mins`
      : i18n('joinWaitlistFree')
  }, [i18n, waitlistStatus, waitlistTime, isClosed])

  const buttonLink = useMemo(() =>
    businessId
      ? {
        link: `https://www.yelp.com/waitlist/${businessId}`,
        linkType: 'external' as const,
      }
      : undefined
    , [businessId])

  return (
    <div className={classnames(styles.JoinWaitlist, className)}>

      <Link
        onClick={onClick}
        primary={primary}
        secondary={secondary ?? !primary}
        link={buttonLink}
        className={styles.button}
      >
        <span className={styles.button__title}>Join Waitlist</span>
        <span
          className={classnames(styles.button__subtitle, {
            [styles.button__subtitle__closed]: isClosed,
          })}
        >
          {buttonLabel}
        </span>
      </Link>
    </div>
  )
}

JoinWaitlist.displayName = 'JoinWaitlist'

export default JoinWaitlist
